import React from "react";
import "./style.scss";
import { useDispatch, useSelector } from "react-redux";
import { setIsActual, setIsPredicted } from "../../../services/actions/GisAction";

const FilterRoadPredict = () => {
  const dispatch = useDispatch();

  const {isActual, isPredicted} = useSelector((state) => ({
    isActual: state.gis.isActual,
    isPredicted: state.gis.isPredicted
  }));

  // チェックボックスの状態が変更されたときに呼ばれる関数
  const handleChangeActual = (evt) => {
    dispatch(setIsActual(evt.target.checked));
  };
  const handleChangePredict = (evt) => {
    dispatch(setIsPredicted(evt.target.checked));
  };

  return <>
    <div className="filter-predicted-card">
      <span>
        <input type="checkbox" id="check_actual" checked={isActual} onChange={handleChangeActual} />
        <label htmlFor="check_actual">Actual</label>
      </span>
      <span>
        <input type="checkbox" id="check_predicted" checked={isPredicted} onChange={handleChangePredict}  />
        <label htmlFor="check_predicted">Predicted</label>
      </span>
    </div>
  </>
};
export default FilterRoadPredict;